import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { TrackedNotificationBox } from '@eneco/components/TrackedNotificationBox/TrackedNotificationBox';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';

import { useMeterReadingsFlow } from '../state/MeterReadingsFlow.machine';


export const ReadingIntake: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/ReadingIntake.${label}.${locale}.json`)}>
      <ReadingIntakeComponent />
    </I18nProvider>
  );
};

export const ReadingIntakeComponent: FC = () => {
  const { state } = useMeterReadingsFlow();
  const { t, isLoading } = useTranslation();

  const readingIntakeError = state.matches({ READING_INTAKE: 'error' });

  if (isLoading || !readingIntakeError) return <Skeleton height={450} />;

  return (
    <TrackedNotificationBox
      variant="error"
      isAlert={false}
      title={t('title')}
      text={<RichText html={t('content')}></RichText>}
    />
  );
};
